import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 1v22h18V9c0-6-2-8-8-8zm6.33 12.846.582.242.242.581C10.94 16.556 11.334 17.5 12 17.5s1.06-.944 1.846-2.83l.242-.582.581-.242C16.556 13.06 17.5 12.666 17.5 12s-.944-1.06-2.83-1.846l-.582-.242-.242-.581C13.06 7.444 12.666 6.5 12 6.5s-1.06.944-1.846 2.83l-.242.582-.581.242C7.444 10.94 6.5 11.334 6.5 12s.944 1.06 2.83 1.846"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarFilledSize24Glyph.displayName = 'DocumentStarFilledSize24Glyph';
